<template>
<div>
    <!-- loader -->
    <Loader />
    <!-- loader -->

    <!-- login-area -->
    <section class="login-area">
        <div class="container">
            <div class="row">
                <div class="col-12">
                    <div class="form-area">
                        <div class="login-form">
                            <div class="form-logo">
                                <router-link to="/"><img class="img-fluid" src="@/assets/img/logo.svg" alt="logo"></router-link>
                                <h3>Forgot password</h3>
                            </div>
                            <form @submit.prevent="forgotSubmit" class="wow fadeInRight" data-wow-duration="1s" data-wow-delay="1s">
                                <label for="email">
                                    <p class="label-txt label-active">Email address</p>
                                    <svg class="log-icon" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="24px" height="24px" viewBox="0 0 24 24" version="1.1">
                                        <title>icons/stroke/email</title>
                                        <defs>
                                            <path d="M19,18 L5,18 C4.449,18 4,17.552 4,17 L4,7.25 L11.4,12.8 C11.578,12.934 11.789,13 12,13 C12.211,13 12.422,12.934 12.6,12.8 L20,7.25 L20,17 C20,17.552 19.551,18 19,18 L19,18 Z M18.333,6 L12,10.75 L5.667,6 L18.333,6 Z M19,4 L5,4 C3.346,4 2,5.346 2,7 L2,17 C2,18.654 3.346,20 5,20 L19,20 C20.654,20 22,18.654 22,17 L22,7 C22,5.346 20.654,4 19,4 L19,4 Z" id="path-1" />
                                        </defs>
                                        <g id="icons/stroke/email" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                                            <mask id="mask-2" fill="white">
                                                <use xlink:href="#path-1" />
                                            </mask>
                                            <use id="🎨-Icon-Сolor" fill="#180660" xlink:href="#path-1" />
                                        </g>
                                    </svg>
                                    <input type="email" v-model="forgotEmail" class="input input-active" required />
                                </label>
                                <button type="submit" class="login-btns" :disabled="loading">Reset your password</button>
                            </form>
                            <h6>or</h6>
                            <div class="other-login">
                                <router-link to="/login">Back to Login</router-link>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
    <!-- login-area -->
    
</div>
</template>

<script>
import $ from "jquery";
import { ref, onMounted } from "vue";
import { useRouter } from 'vue-router';
import Loader from "@/components/Loader";
import axios from "axios";
// console.log(localStorage);
export default {
    components: {
        Loader
    },
    setup() {
        let base_url = "http://api.streamly.com/uploads/";
        const router = useRouter();
        let forgotEmail = ref('');

        const forgotSubmit = async () => {
            $('.login-btns').attr('disabled', true);
            window.showHideMainLoader(true);
            const postFormData = new FormData();
            postFormData.append('email', forgotEmail.value);
            await axios
                .post(axios.defaults.baseUrl + "forgotPassword",
                    postFormData
                )
                .then((response) => {
                    // console.log(response);
                    localStorage.setItem("forgot_user_id", response.data.data.userData.id);
                    localStorage.setItem("forgot_email", response.data.data.userData.email);
                    localStorage.setItem("forgot_otp", response.data.data.otp);
                    localStorage.setItem("forgot_phone", response.data.data.phone_no);
                    router.push('/forgot-password/otp-sent');
                    window.showHideMainLoader(false);
                    // $('.login-btns').removeAttr('disabled');
                })
                .catch((error) => {
                    window.showHideMainLoader(false);
                    showToast(error.response.data.status, error.response.data.message);
                    $('.login-btns').removeAttr('disabled');
                    return false;
                });
        }
        const addClass = (elementName, className) => {
            $(elementName).addClass(className);
        }
        const removeClass = (elementName, className) => {
            $(elementName).removeClass(className);
        }
        const showToast = (toastIcon, toastMessage) => {
            window.toast.fire({
                icon: toastIcon,
                title: toastMessage,
            });
        }
        const openModal = () => {};
        const closeModal = () => {};
        onMounted(() => {
            setTimeout(() => {
                window.showHideMainLoader(false);
            }, 500);
        });

        return {
            openModal,
            closeModal,
            base_url,
            forgotSubmit,
            addClass,
            removeClass,
            showToast,
            forgotEmail
        };
    },
};
</script>
